<template>
  <Page title="Zapomniane hasło">
    <UserForgotPassword />
  </Page>
</template>

<script>
import Page from "@/components/Elements/Page";
import ViewMixin from "@/mixins/View";
import UserForgotPassword from "@/components/UserAccount/UserForgotPassword";

export default {
  name: "ForgotPasswordView",
  components: {
    Page,
    UserForgotPassword
  },
  mixins: [ViewMixin]
};
</script>
